import DateRangeFilterMenu from './DateRangeFilterMenu.js';
import SingleDateFilterMenu from './SingleDateFilterMenu.js';
import SingleRangeSwitcherMenu from './SingleRangeSwitcherMenu.js';
import TextFilterMenu from './TextFilterMenu.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/defineProperty';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'react';
import 'prop-types';
import '@elliemae/ds-date-range-picker';
import '@elliemae/ds-date-picker';
import '@elliemae/ds-basic/Popper';
import '@elliemae/ds-icons/DatePicker2';
import '@elliemae/ds-basic/Button';
import 'moment';
import '@elliemae/ds-classnames';
import './defaultDateFormat.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import 'lodash';
import '@elliemae/ds-dropdownmenu';
import '@elliemae/ds-menu';
import '@elliemae/ds-icons/SearchSmall';

var ComponentTypes = {
  'date-range': DateRangeFilterMenu,
  'single-date': SingleDateFilterMenu,
  'date-switcher': SingleRangeSwitcherMenu,
  string: TextFilterMenu
};
function getFilterMenuByType(type) {
  return ComponentTypes[type] || ComponentTypes.string;
}

export default getFilterMenuByType;
//# sourceMappingURL=getFilterMenuByType.js.map
